/* SliderComponent template */
import { FunctionalComponent, h, Host } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import NavigationArrowsTemplate from './navigation-arrows.template';
import NavigationBulletsTemplate from './navigation-bullets.template';
import { SliderComponent } from '../cwc-slider';

/**
 * Definition of  parameters that the template needs to work.
 */
interface SliderTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: SliderComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const SliderTemplate: FunctionalComponent<SliderTemplateProps> = ({ controller }) => {
  const getCssVariables = () => {
    if (controller.stageWidth) {
      return {
        '--cwc-slider-item-width': `calc(${Math.ceil(controller.stageWidth / controller.itemsPerPage) - controller.gap * ((controller.itemsPerPage - 1) / controller.itemsPerPage)}px)`,
        '--cwc-slider-stage-gap': `${controller.gap}px`,
      };
    }
    return {};
  };

  return (
    <Host>
      <div
        ref={(el) => (controller.canvas = el as HTMLElement)}
        data-dragging={controller.dragging}
        class="canvas"
        tabindex="-1"
      >
        <div
          ref={(el) => (controller.stage = el as HTMLElement)}
          data-snap={controller.snap}
          data-moving={controller.mouseMoving}
          class="stage"
          tabindex="-1"
          style={getCssVariables()}
        >
          <slot onSlotchange={() => controller.handleSlotChange()} />
        </div>

        <NavigationArrowsTemplate controller={controller} />
      </div>

      <slot name="preview" />
      {controller.bullets && <NavigationBulletsTemplate controller={controller} />}
    </Host>
  );
};

export default SliderTemplate;
